import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { Subscriber } from '../../../types/subscriber';
import {  SubscriberStatus, TrainingRequestStatus } from '../../../types/enums';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';

type OpenDeleteDialogFn = (subscriber: Subscriber) => void;

// دوال مساعدة لعرض الحالات بألوان
const renderSubscriberStatus = (status: SubscriberStatus) => {
  const styles: { [key in SubscriberStatus]: { color: string, text: string } } = {
    [SubscriberStatus.PENDING]: { color: 'orange', text: 'معلق' },
    [SubscriberStatus.APPROVED]: { color: 'green', text: 'مقبول' },
    [SubscriberStatus.REJECTED]: { color: 'red', text: 'مرفوض' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

const renderTrainingStatus = (status: TrainingRequestStatus) => {
    const styles: { [key in TrainingRequestStatus]: { color: string, text: string } } = {
      [TrainingRequestStatus.NOT_REQUESTED]: { color: 'gray', text: 'لم يطلب' },
      [TrainingRequestStatus.PENDING]: { color: 'blue', text: 'طلب معلق' },
      [TrainingRequestStatus.APPROVED]: { color: 'green', text: 'تمت الموافقة' },
      [TrainingRequestStatus.REJECTED]: { color: 'red', text: 'تم الرفض' },
    };
    const style = styles[status] || { color: 'black', text: status };
    return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
  };

export const getSubscriberColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<Subscriber>[] => [
  {
    header: 'الاسم',
    accessorKey: 'name',
  },
  {
    header: 'البريد الإلكتروني',
    accessorFn: (row) => row.user?.email || 'N/A',
  },
  {
    header: 'حالة الحساب',
    accessorKey: 'status',
    cell: ({ row }) => renderSubscriberStatus(row.original.status),
  },
  {
    header: 'حالة طلب التدريب',
    accessorKey: 'trainingRequestStatus',
    cell: ({ row }) => renderTrainingStatus(row.original.trainingRequestStatus),
  },
  {
    header: 'المؤهل',
    accessorKey: 'qualification',
  },
  {
    header: 'سنة التخرج',
    accessorKey: 'graduation_year',
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const subscriber = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          <Link to={`/admin/subscribers/edit/${subscriber.id}`} className={`${pageStyles.actionButton} ${pageStyles.edit}`} title="عرض / تعديل">
             <Icon as={FaEdit} style={pageStyles.icon } />
          </Link>
          <button onClick={() => openDeleteDialog(subscriber)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
             <Icon as={FaTrashAlt} style={pageStyles.icon } />
          </button>
        </div>
      );
    },
  },
];
